<div *ngIf="!this.noRates && this.marketRateStatus">
    <strong>Conversion rates:</strong>
    <div *ngFor="let rate of this.latestRates">
        1 {{ rate.sourceCurrency }} = {{ rate.targetValue }}
        {{ rate.targetCurrency }}
    </div>
</div>